import { DataStore } from "../datastore";

// Add type for init options
interface InitOptions {
  sdkType: "HeliShop" | "Helium";
}

// Update DataStore type to accept options
declare module "../datastore" {
  interface DataStore {
    init(options?: InitOptions): Promise<void>;
  }
}

export function init() {
  if (typeof window === "undefined") {
    console.log("Window is not defined. Running in a non-browser environment.");
    return;
  }

  const initializeHeliumDataStore = () => {
    if (!window.helium.datastore) {
      window.helium.datastore = DataStore;

      window.helium.datastore
        .init({})
        .then(() => {
          console.log("DataStore initialized successfully.");
        })
        .catch((error) => {
          console.error("Failed to initialize DataStore:", error);
        });
    } else {
      console.log("DataStore already exists.");
    }
  };

  if (
    document.readyState === "complete" ||
    document.readyState === "interactive"
  ) {
    initializeHeliumDataStore();
  } else {
    window.addEventListener("load", initializeHeliumDataStore);
  }
}
